<onboarding-container [hideLogout]="true" [hideForward]="true" [hideBack]="true">
  <img src="assets/img/onboarding/email-confirmation.svg" alt="email-confirmation" class="mb-5 max-w-100" />
  <p class="zero-text p-huge-med">{{ 'onboarding.email-confirmation.headline' | transloco }}</p>
  <p class="zero-text p-base-reg">{{ 'onboarding.email-confirmation.text' | transloco }}</p>
  <p class="zero-text p-base-reg">{{ 'onboarding.email-confirmation.label' | transloco }}</p>
  <a class="zero-text link" [routerLink]="resendPage">{{ 'onboarding.email-confirmation.resend' | transloco }}</a>
</onboarding-container>
